module.exports = __webpack_public_path__ + "static/media/supplyChain.b9bbeefd.jpg";